import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  AD_GROUP,
  CAMPAIGN,
  CREATIVE,
  KEYWORD,
} from 'features/report/common/DomainText'
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from 'utils'
import { setReports } from 'features/report/reportAddSlice'
import { CampaignTypes } from '../../Codes'

const emptyMessages = {
  emptyResult: <div className="inner_tbl">광고운영 결과가 없습니다.</div>,
  selectCampaign: <div className="inner_tbl">캠페인을 먼저 선택해주세요.</div>,
  selectAdGroup: (
    <div className="inner_tbl">캠페인과 광고그룹을 먼저 선택해주세요.</div>
  ),
  targetingType: (
    <div className="inner_tbl">매칭유형 지표는 톡채널검색만 제공됩니다.</div>
  ),
  kakaoFriend: (
    <div className="inner_tbl">카카오친구 지표는 톡채널검색만 제공됩니다.</div>
  ),
}

const useEmptyTableMessage = () => {
  const dispatch = useDispatch()
  const [emptyMessage, setEmptyMessage] = useState(emptyMessages.emptyResult)
  const {
    formValues: {
      domain,
      campaignId,
      adGroupId,
      analysisItem,
      metricsTypes,
      campaignType,
    },
  } = useSelector(state => state.report.reportAdd)

  useEffect(() => {
    if (domain === AD_GROUP && isNullOrUndefinedOrEmpty(campaignId)) {
      dispatch(setReports({ content: [] }))
      setEmptyMessage(emptyMessages.selectCampaign)
    } else if (
      (domain === CREATIVE || domain === KEYWORD) &&
      (isNullOrUndefined(adGroupId) || isNullOrUndefinedOrEmpty(campaignId))
    ) {
      dispatch(setReports({ content: [] }))
      setEmptyMessage(emptyMessages.selectAdGroup)
    } else if (
      (domain === CAMPAIGN ||
        ((domain === AD_GROUP || domain === CREATIVE) &&
          campaignType === CampaignTypes.PREMIUM_LINK)) &&
      analysisItem === 'targetingType'
    ) {
      setEmptyMessage(emptyMessages.targetingType)
    } else if (
      domain === CAMPAIGN &&
      metricsTypes.length === 1 &&
      metricsTypes[0] === 'kakaoFriend'
    ) {
      setEmptyMessage(emptyMessages.kakaoFriend)
    } else {
      setEmptyMessage(emptyMessages.emptyResult)
    }
  }, [
    domain,
    analysisItem,
    metricsTypes,
    campaignType,
    campaignId,
    adGroupId,
    dispatch,
  ])

  return emptyMessage
}

export default useEmptyTableMessage
